module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/bg-header-373b609ddb2a02e6aa8f76c62299df74.png";